import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
    Typography,
    Grid,
    TextField,
    FormControl,
    Autocomplete
} from '@mui/material';
// import Backdrop from '@mui/material/Backdrop';
import { connect } from 'react-redux';
import { useForm } from 'react-hook-form';
import * as emailConfigActions from '../../../store/actions/emailConfig';
import * as Styled from '../../../components/styled-components/Campaign';
// import SpinningLoader from '../components/SpinningLoader';


import appConfig from '../../../config/appConfig';
import RadioButtonGroup from '../../../components/RadioButtonGroup';

const ErrorStyle = {
    color: "red",
    display: 'flex',
    marginTop: '5px'
}

const textboxCss = {
    border: `1px solid ${appConfig.colors.darkblue}`,
    borderRadius: "4px",
    outline: "none",
    '&.MuiFormControl-root': {
        margin: "0"
    },
    '&.MuiTextField-root': {
        backgroundColor: '#fff'
    },
    '& .MuiInputBase-input': {
        backgroundColor: '#fff',
        fontSize: 16,
        fontFamily: appConfig.fontfamily,
        padding: "10px 14px",
        borderRadius: "4px",
        outline: "none",

    },
    '& .MuiOutlinedInput-root': {
        padding: '0',
    }
};

const dropDownlistCss = { mt: 1, mb: 1, borderRadius: "5px", border: `1px solid ${appConfig.colors.darkblue}`, background: "#fcfcfb", width: "100%", '.MuiAutocomplete-input': { height: "5px" } };

const CreateEmailConfiguration = ({ showEmailConfigurations, emailConfigs, headerConfigs, footerConfigs, createEmailConfigData }) => {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const headerOptions = headerConfigs?.headers?.headers?.map((item) => ({ name: item?.defaultConfigFlag ? `${item.name}(Default)` : item.name, code: item.code }));
    const footerOptions = footerConfigs?.footers?.footers?.map((item) => ({ name: item?.defaultConfigFlag ? `${item.name}(Default)` : item.name, code: item.code }));
    
    const [headerConfigError, setHeaderConfigError] = useState(false);
    const [footerConfigError, setFooterConfigError] = useState(false);

    const [defaultValue, setDefaultValue] = useState('No');
    const [selectedHeader, setSelectedHeader] = useState();
    const [selectedFooter, setSelectedFooter] = useState();

    const handleDefaultValue = (e) => {
        setDefaultValue(e.target.value);
    }

    const handleHeaderChange = (value) => {
        setHeaderConfigError(false);
        setSelectedHeader(value.code);
    }

    const handleFooterChange = (value) => {
        setFooterConfigError(false);
        setSelectedFooter(value.code);
    }

    useEffect(() => {
        if(Object.keys(emailConfigs?.createEmailConfigData).length > 0) {
            showEmailConfigurations();
        }
    }, [emailConfigs?.createEmailConfigData])

    
    const onSubmit = (data) => {
        const tempEmailConfigData = {
            name: data?.name,
            code: data?.code,
            defaultConfigFlag: defaultValue === 'Yes',
            headerConfigurationCode: selectedHeader,
            footerConfigurationCode: selectedFooter
        }
        createEmailConfigData(tempEmailConfigData);
    }

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={6} sm={6} xl={6} lg={6} md={6}>
                    <h3><b>Create Email Configuration</b></h3>
                </Grid>
                <Grid item xs={6} xl={6} lg={6} md={6}>
                    <div className='text-align-right'>
                        <Styled.CampaignButton
                            className='text-trans-none'
                            variant="contained"
                            onClick={showEmailConfigurations}
                        >
                            Email Configurations
                        </Styled.CampaignButton>
                    </div>
                </Grid>
            </Grid>
            <hr className='blue-border' />
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2}>
                    <Grid item md={7} xl={7} lg={7} xs={12} sm={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1 }}>Email Configuration Name (Required)</Typography>
                            <TextField
                                {...register('name', { required: true, maxLength: 79 })}
                                margin="normal"
                                id="name"
                                sx={textboxCss}
                                fullWidth
                                inputProps={{ "aria-label": "template name" }}
                            />
                        </div>
                        {errors?.name?.type === "required" && <span style={ErrorStyle}>Please enter Email Configuration name.</span>}
                        {errors?.name?.type === "maxLength" && (<span style={ErrorStyle}>Email Configuration name cannot exceed 80 characters</span>)}
                    </Grid>

                    <Grid item md={7} xl={7} lg={7} sm={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1 }} className="inline-blk">Email Configuration Code (Required)</Typography>
                            <Typography component="p" sx={{ mb: 1 }} className="inline-blk flt-r">Must be 6 characters</Typography>
                            <TextField
                                {...register('code', { required: true, pattern: /^[A-Za-z0-9 ]+$/, maxLength: 6, minLength: 6 })}
                                margin="normal"
                                id="code"
                                sx={textboxCss}
                                fullWidth
                                inputProps={{ "aria-label": "template code" }}
                            />
                        </div>
                        {errors?.code?.type === "required" && <span style={ErrorStyle}>Please enter Email Configuration code.</span>}
                        {errors?.code?.type === "pattern" && (<span style={ErrorStyle}>Special characters not allowed.</span>)}
                        {errors?.code?.type === "maxLength" && (<span style={ErrorStyle}>Email Configuration code must be 6 characters</span>)}
                        {errors?.code?.type === "minLength" && (<span style={ErrorStyle}>Email Configuration code must be 6 characters</span>)}
                    </Grid>
                    <Grid item md={7} xl={7} lg={7} sm={12}>
                        <Typography component="p" sx={{ mb: 1 }} className="inline-blk">Set as default Email Configuration?</Typography>
                        <Typography component="p" sx={{ mb: 1, fontSize: '14px' }} className="inline-blk">(Overrides current default Email Configuration)</Typography>
                            <RadioButtonGroup
                                className={['create-using-account-radio', defaultValue].join(' ')}
                                header=' '
                                value={defaultValue}
                                labels={['Yes', 'No']}
                                handleChange={handleDefaultValue}
                            />
                    </Grid>                   
                    <Grid item md={7} xl={7} lg={7} sm={12}>
                        <Typography component="p" sx={{ mt: 1, mb: 1 }}>Select Header (Required)</Typography>
                        <FormControl sx={dropDownlistCss}>
                            <Autocomplete
                                disablePortal
                                disableClearable
                                className='autocomplete-class'
                                value={headerOptions?.find(o=>o.code === selectedHeader) || null}
                                options={headerOptions}
                                isOptionEqualToValue={(o, v) => o.code === v.code}
                                getOptionLabel={
                                    (o) => { return o ? `${o.code} - ${o.name}` : ''}
                                }
                                renderInput={(params) => {
                                    const newParams = { ...params, inputProps: { ...params.inputProps, "aria-label": "email header" } }
                                    return <TextField {...newParams} />
                                }}
                                onChange={(e, val) => { handleHeaderChange(val) }}
                            />
                        </FormControl>
                        {headerConfigError && <span style={ErrorStyle}>Please select a Header for Email Configuration. </span>}
                    </Grid>
                    <Grid item md={7} xl={7} lg={7} sm={12}>
                        <Typography component="p" sx={{ mt: 1, mb: 1 }}>Select Footer (Required)</Typography>
                        <FormControl sx={dropDownlistCss}>
                            <Autocomplete
                                disablePortal
                                disableClearable
                                className='autocomplete-class'
                                value={footerOptions?.find(o=>o.code === selectedFooter) || null}
                                options={footerOptions}
                                isOptionEqualToValue={(o, v) => o.code === v.code}
                                getOptionLabel={
                                    (o) => { return o ? `${o.code} - ${o.name}` : ''}
                                }
                                renderInput={(params) => {
                                    const newParams = { ...params, inputProps: { ...params.inputProps, "aria-label": "email footer" } }
                                    return <TextField {...newParams} />
                                }}
                                onChange={(e, val) => { handleFooterChange(val) }}
                            />
                        </FormControl>
                        {footerConfigError && <span style={ErrorStyle}>Please select a Footer for Email Configuration. </span>}
                    </Grid>
                    <Grid item xs={12} sm={12} xl={12} lg={12} md={12}>
                        <hr className='blue-border' />
                    </Grid>
                    <Grid container spacing={1} sx={{ marginLeft: "10px" }}>
                        <Grid item xs={12} sm={4} xl={1.5} lg={1.5} md={1.5}>
                            <Styled.CancelButton
                                variant="outlined"
                                sx={{ mt: 3, fontFamily: appConfig.fontfamily, textTransform: 'capitalize', width: '100%', height: "50px" }}
                                onClick={showEmailConfigurations}
                            >
                                Cancel
                            </Styled.CancelButton>
                        </Grid>
                        <Grid item xs={12} sm={8} xl={5.6} lg={5.6} md={5.6}>
                            <Styled.CampaignButton
                                type='submit'
                                variant="contained"
                                sx={{ mt: 3, fontFamily: appConfig.fontfamily, textTransform: 'capitalize', width: '100%', height: "50px" }}
                            >
                                Create
                            </Styled.CampaignButton>
                        </Grid>
                    </Grid>
                </Grid>
            </form>
        </div>
    );
}

CreateEmailConfiguration.propTypes = {
    showEmailConfigurations: PropTypes.func.isRequired,
    emailConfigs: PropTypes.object.isRequired,
    headerConfigs: PropTypes.object.isRequired,
    footerConfigs: PropTypes.object.isRequired,
    createEmailConfigData: PropTypes.func.isRequired,
}
const mapStateToProps = (state) => ({ 
    emailConfigs: state.emailConfig,
    headerConfigs: state.header, 
    footerConfigs: state.footer 
 })

const mapDispatchToProps = (dispatch) => {
    return {
        createEmailConfigData: (fields) => dispatch(emailConfigActions.createEmailConfig(fields)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateEmailConfiguration);